import type {
  CustomerContractNoteAttachmentDeleteApiData,
  CustomerContractNoteAttachmentDeleteApiResponses,
  CustomerContractNoteAttachmentsBulkCreateApiData,
  CustomerContractNoteAttachmentsBulkCreateApiResponses,
  CustomerContractNoteCreateApiData,
  CustomerContractNoteCreateApiResponses,
  CustomerContractNoteDeleteApiData,
  CustomerContractNoteDeleteApiResponses,
  CustomerContractNoteGetApiData,
  CustomerContractNoteGetApiResponses,
  CustomerContractNoteListApiData,
  CustomerContractNoteListApiResponses,
  CustomerContractNoteListForCustomerApiData,
  CustomerContractNoteListForCustomerApiResponses,
  CustomerContractNotePatchApiData,
  CustomerContractNotePatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';
import { noteAttachmentFilesFormData } from '../noteAttachmentFormData';

// Customer contract notes

export const getCustomerContractNoteUrls = {
  getPaginatedCustomerContractNotes: dataEndpoint<
    CustomerContractNoteListApiData,
    CustomerContractNoteListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('customer-contract-notes/', queryParams)
  }),
  getCustomerContractNotesForCustomer: dataEndpoint<
    CustomerContractNoteListForCustomerApiData,
    CustomerContractNoteListForCustomerApiResponses
  >({
    getUrl: (queryParams) => apiUrl('customer-contract-notes/for-customer/', queryParams)
  }),
  getCustomerContractNote: dataEndpoint<CustomerContractNoteGetApiData, CustomerContractNoteGetApiResponses>({
    getUrl: ({ customerContractNoteId }) => apiUrl(`customer-contract-notes/${customerContractNoteId}/`)
  }),
  postCustomerContractNote: responseEndpoint<CustomerContractNoteCreateApiData, CustomerContractNoteCreateApiResponses>(
    {
      getUrl: () => apiUrl('customer-contract-notes/'),
      getBody: (data) => data
    }
  ),
  patchCustomerContractNote: responseEndpoint<CustomerContractNotePatchApiData, CustomerContractNotePatchApiResponses>({
    getUrl: ({ customerContractNoteId }) => apiUrl(`customer-contract-notes/${customerContractNoteId}/`),
    getBody: ({ customerContractNoteId: _, ...body }) => body
  }),
  deleteCustomerContractNote: dataEndpoint<CustomerContractNoteDeleteApiData, CustomerContractNoteDeleteApiResponses>({
    getUrl: ({ customerContractNoteId }) => apiUrl(`customer-contract-notes/${customerContractNoteId}/`)
  }),
  postCustomerContractNoteAttachmentsBulk: responseEndpoint<
    CustomerContractNoteAttachmentsBulkCreateApiData,
    CustomerContractNoteAttachmentsBulkCreateApiResponses
  >({
    getUrl: ({ customerContractNoteId }) =>
      apiUrl(`customer-contract-notes/${customerContractNoteId}/attachments/bulk/`),
    getHeaders: () => ({ 'Content-Type': 'multipart/form-data' }),
    getBody: ({ files }) => noteAttachmentFilesFormData(files),
    skipBodyTransformation: true
  }),
  deleteCustomerContractNoteAttachment: dataEndpoint<
    CustomerContractNoteAttachmentDeleteApiData,
    CustomerContractNoteAttachmentDeleteApiResponses
  >({
    getUrl: ({ customerContractNoteId, attachmentId }) =>
      apiUrl(`customer-contract-notes/${customerContractNoteId}/attachments/${attachmentId}/`)
  })
};
